import { render, staticRenderFns } from "./AcoesEnviarMensagem.vue?vue&type=template&id=35a4cbde&scoped=true"
import script from "./AcoesEnviarMensagem.vue?vue&type=script&lang=js"
export * from "./AcoesEnviarMensagem.vue?vue&type=script&lang=js"
import style0 from "./AcoesEnviarMensagem.vue?vue&type=style&index=0&id=35a4cbde&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a4cbde",
  null
  
)

export default component.exports